export enum Honorific {
  SR = 'Sr.',
  SRA = 'Sra.',
  DR = 'Dr.',
  DRA = 'Dra.',
}
